export type ChoiceOption = {
  label: string
  value: null | string | number | boolean
}
